import React from 'react';
import { useNotesTrash } from '@teetsh/app/src/containers/UserSettings/Trash/Notes/useNotesTrash';
import { useRestoreNote } from '@teetsh/app/src/containers/UserSettings/Trash/Notes/useRestoreNote';
import { RestorableList } from '@teetsh/app/src/containers/UserSettings/Trash/components/RestorableList';
import { RestorableNote } from '@teetsh/app/src/containers/Dashboard/Todolist/types';

export function NotesRestorableList() {
  const { data = [] } = useNotesTrash();
  const restore = useRestoreNote();

  return <RestorableList<RestorableNote> items={data} restore={restore} />;
}
